import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.95306 2.63754C11.1269 2.32085 13.699 2.32077 15.8651 2.63761C19.1453 3.11977 21.6885 5.66092 22.171 8.94024C22.3309 10.0323 22.4004 11.1929 22.4004 12.4C22.4004 13.6123 22.3219 14.7714 22.1627 15.8591L22.1622 15.8625C21.6707 19.1375 19.1396 21.6798 15.8574 22.1623L15.8556 22.1625C14.7601 22.3215 13.6009 22.4 12.3962 22.4C11.1917 22.4 10.0321 22.3215 8.94408 22.1624L8.94114 22.162C5.65545 21.6708 3.12086 19.1401 2.63822 15.8598C2.47898 14.7721 2.40039 13.6123 2.40039 12.4C2.40039 11.1877 2.47888 10.0286 2.63813 8.9409L2.63862 8.93755C3.13021 5.66182 5.66194 3.11988 8.95225 2.63765L8.95306 2.63754Z",
  fill: "#3C75FF"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8.88098 2.14276L8.8808 2.14278L8.88 2.1429L8.87975 2.14294C5.37027 2.65728 2.66824 5.37106 2.14415 8.86335L2.14389 8.86512L2.1434 8.86846L2.63739 8.94079L2.1434 8.86846C1.98024 9.98292 1.90039 11.1665 1.90039 12.4C1.90039 13.6335 1.98033 14.8178 2.1435 15.9322L2.14355 15.9325C2.65841 19.432 5.36487 22.1329 8.86722 22.6565L8.86795 22.6566L8.87089 22.657L8.87171 22.6571C9.98635 22.8202 11.1703 22.9 12.3962 22.9C13.6224 22.9 14.8057 22.8201 15.9274 22.6574L15.9281 22.6573L15.9298 22.657L15.9301 22.657C19.4317 22.1423 22.1327 19.4279 22.6566 15.9367L22.6567 15.9358L22.6572 15.9325L22.6574 15.9315C22.8205 14.8171 22.9004 13.6335 22.9004 12.4C22.9004 11.1744 22.8299 9.98886 22.6657 8.86781L22.6657 8.86746C22.151 5.3696 19.4362 2.65715 15.9379 2.14293L15.9375 2.14288C13.7233 1.819 11.1025 1.81912 8.88098 2.14276Z",
  stroke: "black",
  "stroke-opacity": "0.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.0952 7.94754C18.7427 8.46426 18.8488 9.40807 18.3321 10.0556L13.8288 15.699C12.8857 16.8808 11.156 17.0579 9.99301 16.0917L6.60108 13.2738C5.96386 12.7444 5.87644 11.7987 6.40582 11.1615C6.9352 10.5243 7.88092 10.4368 8.51814 10.9662L11.6747 13.5886L15.9872 8.1844C16.5039 7.53687 17.4477 7.43082 18.0952 7.94754Z",
  fill: "white"
}, null, -1);
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_4);
}
const icV2BadgeOwndRoundColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2BadgeOwndRoundColor as default
};
